// @workflow assistant.reply-blocks
/**
 * What this build draws, sent as `client.blocks`: the block kinds plus the timeline chart, which
 * arrives as a chart/visual (not a `block` event) but is offered by the server only to clients that list it.
 * No Vue or path-alias imports, so `npm run test:unit` (node --test) can load it directly.
 */
import { BLOCK_KINDS } from './blockContract.js';
import { CHART_KIND } from './chartEngine.js';

export const CLIENT_DRAWS = Object.freeze([...BLOCK_KINDS, CHART_KIND.TIMELINE]);
